var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwinRightAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.00001C0 2.23858 2.23858 0 5 0H82.0787C86.5273 0 88.7608 5.37349 85.6229 8.52685L46.4403 47.9023L8.52657 85.6245C5.3731 88.7621 0 86.5285 0 82.08V5.00001Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 95C100 97.7614 97.7614 100 95 100H17.9213C13.4727 100 11.2392 94.6265 14.3771 91.4732L53.5597 52.0977L91.4734 14.3755C94.6269 11.2379 100 13.4715 100 17.92V95Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinRightAngleLeft);
export default __webpack_public_path__ + "static/media/TwinRightAngleLeft.bcff2201bf32c59775f473159dde0677.svg";
export { ForwardRef as ReactComponent };